import React from 'react';
import { makeStyles } from 'tss-react/mui';
//import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const useStyles = makeStyles()((theme) => ({
    button: {
        display: 'block',
        marginTop: theme.spacing(1),
    },
    formControl: {
        margin: theme.spacing(0),
        minWidth: 120,
    },
}));



export default function FormSelect(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);



    const handleChange = (event) => {
        props.onSelectValue(event);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };
    return (
        <FormControl className={classes.formControl}>
            {
                <Select
                    labelId="demo-controlled-open-select-label"
                    id="demo-controlled-open-select"
                    name={props.name || "select"}
                    open={open}
                    onClose={handleClose}
                    onOpen={handleOpen}
                    value={props.defaultValue}
                    onChange={handleChange}
                    color="primary"
                    variant="standard"
                    className="mb-3 search-text"
                >
                    {

                        props?.selectData?.map((el) =>
                            <MenuItem value={el.value} key={el.key} selected={el.key === 'English'} id="details-menu" > {el.value} </MenuItem>)
                    }
                </Select>
            }
        </FormControl>
    );
}